import React from 'react'
import { Box } from '@mui/material'
import { BadgeTile } from './BadgeTile'
import { BADGE_GAP } from './constants'

/**
 * AC7. Single-level designations the donor has earned, in a grid at the same
 * badge size as the milestone rail so the page reads as one set. Unearned ones
 * never reach here - the endpoint leaves them out.
 */
export const OtherEarnedBadges = ({ badges }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: 'repeat(2, minmax(0, 1fr))',
        sm: 'repeat(3, minmax(0, 1fr))',
        md: 'repeat(6, minmax(0, 1fr))',
      },
      gap: `${BADGE_GAP}px`,
    }}
  >
    {badges.map(badge => (
      <BadgeTile
        key={badge.designation_id}
        name={badge.name}
        imageUrl={badge.badge_image_url}
      />
    ))}
  </Box>
)
